// src/components/jb-select/jb-select.scss?inline
import { css } from "lit-element/lit-element.js";
var jb_select_default = css`*,
*::before,
*::after {
  box-sizing: border-box;
}

div,
object,
iframe,
h1,
h2,
h3,
h4,
h5,
h6,
p,
blockquote,
ol,
ul,
li,
form,
legend,
label,
table,
header,
footer,
nav,
section,
figure {
  margin: 0;
  padding: 0;
}

a {
  color: inherit;
}

:host {
  --spacing-none: 0;
  --spacing-base: 4px;
  --spacing-3xs: 8px;
  --spacing-2xs: 12px;
  --spacing-xs: 16px;
  --spacing-s: 20px;
  --spacing-sm: 20px;
  --spacing-m: 24px;
  --spacing-lm: 28px;
  --spacing-l: 32px;
  --spacing-xl: 32px;
  --spacing-2xl: 36px;
  --spacing-3xl: 36px;
  --spacing-4xl: 72px;
  --spacing-small: var(--spacing-lm);
  --spacing-medium: var(--spacing-3xl);
  --spacing-big: var(--spacing-4xl);
  --spacing-gap: 16px;
}

@media screen and (width >= 1281px) {
  :host {
    --spacing-sm: 24px;
    --spacing-m: 32px;
    --spacing-lm: 36px;
    --spacing-l: 40px;
    --spacing-xl: 48px;
    --spacing-2xl: 64px;
    --spacing-3xl: 72px;
    --spacing-4xl: 144px;
    --spacing-small: var(--spacing-lm);
    --spacing-medium: var(--spacing-3xl);
    --spacing-big: var(--spacing-4xl);
    --spacing-gap: 40px;
  }
}
/* stylelint-disable */
/* stylelint-enable */
jb-dropdown .iseservices .ts-wrapper .ts-control,
jb-select .iseservices .ts-wrapper .ts-control, jb-dropdown .ts-wrapper,
jb-select .ts-wrapper, jb-dropdown p,
jb-select p, jb-dropdown label,
jb-select label, jb-dropdown .ts-dropdown .option span:not(.highlight),
jb-select .ts-dropdown .option span:not(.highlight), jb-dropdown .ts-dropdown,
jb-dropdown .ts-control,
jb-dropdown .ts-control input,
jb-select .ts-dropdown,
jb-select .ts-control,
jb-select .ts-control input {
  font-family: VerlagSSm, Tahoma, sans-serif;
  font-style: normal;
  font-weight: 300;
}

jb-dropdown .ts-dropdown .option span:not(.highlight),
jb-select .ts-dropdown .option span:not(.highlight), jb-dropdown .ts-dropdown,
jb-dropdown .ts-control,
jb-dropdown .ts-control input,
jb-select .ts-dropdown,
jb-select .ts-control,
jb-select .ts-control input {
  font-size: 16px;
  line-height: 26px;
}

jb-dropdown p,
jb-select p, jb-dropdown label,
jb-select label {
  font-size: 13px;
  line-height: 20px;
}

jb-dropdown .ts-wrapper,
jb-select .ts-wrapper {
  color: rgba(var(--rgb-primary, 20, 30, 85), var(--text-opacity, 0.8));
  font-size: 16px;
  line-height: 26px;
}

jb-dropdown .iseservices .ts-wrapper .ts-control,
jb-select .iseservices .ts-wrapper .ts-control {
  color: rgb(var(--rgb-primary, 20, 30, 85));
  font-size: 26px;
  line-height: 35px;
}
@media (min-width: 1281px) {
  jb-dropdown .iseservices .ts-wrapper .ts-control,
  jb-select .iseservices .ts-wrapper .ts-control {
    font-size: 31px;
    line-height: 42px;
  }
}

:host {
  --spacing-none: 0;
  --spacing-base: 4px;
  --spacing-3xs: 8px;
  --spacing-2xs: 12px;
  --spacing-xs: 16px;
  --spacing-s: 20px;
  --spacing-sm: 20px;
  --spacing-m: 24px;
  --spacing-lm: 28px;
  --spacing-l: 32px;
  --spacing-xl: 32px;
  --spacing-2xl: 36px;
  --spacing-3xl: 36px;
  --spacing-4xl: 72px;
  --spacing-small: var(--spacing-lm);
  --spacing-medium: var(--spacing-3xl);
  --spacing-big: var(--spacing-4xl);
  --spacing-gap: 16px;
}

@media screen and (width >= 1281px) {
  :host {
    --spacing-sm: 24px;
    --spacing-m: 32px;
    --spacing-lm: 36px;
    --spacing-l: 40px;
    --spacing-xl: 48px;
    --spacing-2xl: 64px;
    --spacing-3xl: 72px;
    --spacing-4xl: 144px;
    --spacing-small: var(--spacing-lm);
    --spacing-medium: var(--spacing-3xl);
    --spacing-big: var(--spacing-4xl);
    --spacing-gap: 40px;
  }
}
:host {
  color: var(--host-color, #141e55);
}

jb-dropdown,
jb-select {
  /**
   * tom-select.css (v//@@version)
   * Copyright (c) contributors
   *
   * Licensed under the Apache License, Version 2.0 (the "License"); you may not use this
   * file except in compliance with the License. You may obtain a copy of the License at:
   * http://www.apache.org/licenses/LICENSE-2.0
   *
   * Unless required by applicable law or agreed to in writing, software distributed under
   * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF
   * ANY KIND, either express or implied. See the License for the specific language
   * governing permissions and limitations under the License.
   *
   */
  /* stylelint-disable function-name-case */
  /* stylelint-disable-line */
  display: inline-block;
  position: relative;
  width: 100%;
}
jb-dropdown .ts-control,
jb-select .ts-control {
  border: 1px solid #d0d0d0;
  padding: 8px 8px;
  width: 100%;
  overflow: hidden;
  position: relative;
  z-index: 1;
  box-sizing: border-box;
  box-shadow: inset 0 1px 1px rgba(0, 0, 0, 0.1);
  border-radius: 3px;
  display: flex;
  flex-wrap: wrap;
}
.ts-wrapper.multi.has-items jb-dropdown .ts-control,
.ts-wrapper.multi.has-items jb-select .ts-control {
  padding: calc(8px - 2px - 0) 8px calc(8px - 2px - 3px - 0);
}
.full jb-dropdown .ts-control,
.full jb-select .ts-control {
  background-color: #fff;
}
.disabled jb-dropdown .ts-control, .disabled jb-dropdown .ts-control *,
.disabled jb-select .ts-control,
.disabled jb-select .ts-control * {
  cursor: default !important;
}
.focus jb-dropdown .ts-control,
.focus jb-select .ts-control {
  box-shadow: inset 0 1px 2px rgba(0, 0, 0, 0.15);
}
jb-dropdown .ts-control > *,
jb-select .ts-control > * {
  vertical-align: baseline;
  display: inline-block;
}
.ts-wrapper.multi jb-dropdown .ts-control > div,
.ts-wrapper.multi jb-select .ts-control > div {
  cursor: pointer;
  margin: 0 3px 3px 0;
  padding: 2px 6px;
  background: #141e55;
  color: #fff;
  border: 0 solid #0073bb;
}
.ts-wrapper.multi jb-dropdown .ts-control > div.active,
.ts-wrapper.multi jb-select .ts-control > div.active {
  background: #92c836;
  color: #fff;
  border: 0 solid #00578d;
}
.ts-wrapper.multi.disabled jb-dropdown .ts-control > div, .ts-wrapper.multi.disabled jb-dropdown .ts-control > div.active,
.ts-wrapper.multi.disabled jb-select .ts-control > div,
.ts-wrapper.multi.disabled jb-select .ts-control > div.active {
  color: white;
  background: #818181;
  border: 0 solid #aaaaaa;
}
jb-dropdown .ts-control > input,
jb-select .ts-control > input {
  flex: 1 1 auto;
  min-width: 7rem;
  display: inline-block !important;
  padding: 0 !important;
  min-height: 0 !important;
  max-height: none !important;
  max-width: 100% !important;
  margin: 0 !important;
  text-indent: 0 !important;
  border: 0 none !important;
  background: none !important;
  line-height: inherit !important;
  user-select: auto !important;
  box-shadow: none !important;
}
jb-dropdown .ts-control > input::-ms-clear,
jb-select .ts-control > input::-ms-clear {
  display: none;
}
jb-dropdown .ts-control > input:focus,
jb-select .ts-control > input:focus {
  outline: none !important;
}
.has-items jb-dropdown .ts-control > input,
.has-items jb-select .ts-control > input {
  margin: 0 4px !important;
}
jb-dropdown .ts-control.rtl,
jb-select .ts-control.rtl {
  text-align: right;
}
jb-dropdown .ts-control.rtl.single .ts-control:after,
jb-select .ts-control.rtl.single .ts-control:after {
  left: 15px;
  right: auto;
}
jb-dropdown .ts-control.rtl .ts-control > input,
jb-select .ts-control.rtl .ts-control > input {
  margin: 0 4px 0 -2px !important;
}
.disabled jb-dropdown .ts-control,
.disabled jb-select .ts-control {
  opacity: 0.5;
  background-color: #fafafa;
}
.input-hidden jb-dropdown .ts-control > input,
.input-hidden jb-select .ts-control > input {
  opacity: 0;
  position: absolute;
  left: -10000px;
}
jb-dropdown .ts-dropdown,
jb-select .ts-dropdown {
  position: absolute;
  top: 100%;
  left: 0;
  width: 100%;
  z-index: 10;
  border: 1px solid #d0d0d0;
  background: #fff;
  margin: 0.25rem 0 0;
  border-top: 0 none;
  box-sizing: border-box;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1);
  border-radius: 0 0 3px 3px;
}
jb-dropdown .ts-dropdown [data-selectable],
jb-select .ts-dropdown [data-selectable] {
  cursor: pointer;
  overflow: hidden;
}
jb-dropdown .ts-dropdown [data-selectable] .highlight,
jb-select .ts-dropdown [data-selectable] .highlight {
  background: rgba(125, 168, 208, 0.2);
  border-radius: 1px;
}
jb-dropdown .ts-dropdown .option,
jb-dropdown .ts-dropdown .optgroup-header,
jb-dropdown .ts-dropdown .no-results,
jb-dropdown .ts-dropdown .create,
jb-select .ts-dropdown .option,
jb-select .ts-dropdown .optgroup-header,
jb-select .ts-dropdown .no-results,
jb-select .ts-dropdown .create {
  padding: 5px 8px;
}
jb-dropdown .ts-dropdown .option, jb-dropdown .ts-dropdown [data-disabled], jb-dropdown .ts-dropdown [data-disabled] [data-selectable].option,
jb-select .ts-dropdown .option,
jb-select .ts-dropdown [data-disabled],
jb-select .ts-dropdown [data-disabled] [data-selectable].option {
  cursor: inherit;
  opacity: 0.5;
}
jb-dropdown .ts-dropdown [data-selectable].option,
jb-select .ts-dropdown [data-selectable].option {
  opacity: 1;
  cursor: pointer;
}
jb-dropdown .ts-dropdown .optgroup:first-child .optgroup-header,
jb-select .ts-dropdown .optgroup:first-child .optgroup-header {
  border-top: 0 none;
}
jb-dropdown .ts-dropdown .optgroup-header,
jb-select .ts-dropdown .optgroup-header {
  color: #303030;
  background: #fff;
  cursor: default;
}
jb-dropdown .ts-dropdown .active,
jb-select .ts-dropdown .active {
  background-color: #f5fafd;
  color: #495c68;
}
jb-dropdown .ts-dropdown .active.create,
jb-select .ts-dropdown .active.create {
  color: #495c68;
}
jb-dropdown .ts-dropdown .create,
jb-select .ts-dropdown .create {
  color: rgba(48, 48, 48, 0.5);
}
jb-dropdown .ts-dropdown .spinner,
jb-select .ts-dropdown .spinner {
  display: inline-block;
  width: 30px;
  height: 30px;
  margin: 5px 8px;
}
jb-dropdown .ts-dropdown .spinner::after,
jb-select .ts-dropdown .spinner::after {
  content: " ";
  display: block;
  width: 24px;
  height: 24px;
  margin: 3px;
  border-radius: 50%;
  border: 5px solid #d0d0d0;
  border-color: #d0d0d0 transparent #d0d0d0 transparent;
  animation: lds-dual-ring 1.2s linear infinite;
}
@keyframes lds-dual-ring {
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(360deg);
  }
}
jb-dropdown .ts-dropdown-content,
jb-select .ts-dropdown-content {
  overflow: hidden auto;
  max-height: 200px;
  scroll-behavior: smooth;
}
jb-dropdown .ts-wrapper.plugin-drag_drop .ts-dragging,
jb-select .ts-wrapper.plugin-drag_drop .ts-dragging {
  color: transparent !important;
}
jb-dropdown .ts-wrapper.plugin-drag_drop .ts-dragging > *,
jb-select .ts-wrapper.plugin-drag_drop .ts-dragging > * {
  visibility: hidden !important;
}
jb-dropdown .plugin-checkbox_options:not(.rtl) .option input,
jb-select .plugin-checkbox_options:not(.rtl) .option input {
  margin-right: 0.5rem;
}
jb-dropdown .plugin-checkbox_options.rtl .option input,
jb-select .plugin-checkbox_options.rtl .option input {
  margin-left: 0.5rem;
}
jb-dropdown .plugin-clear_button,
jb-select .plugin-clear_button {
  --ts-pr-clear-button: 1em;
}
jb-dropdown .plugin-clear_button .clear-button,
jb-select .plugin-clear_button .clear-button {
  opacity: 0;
  position: absolute;
  top: 50%;
  transform: translateY(-50%);
  right: calc(8px - 6px);
  margin-right: 0 !important;
  background: transparent !important;
  transition: opacity 0.5s;
  cursor: pointer;
}
jb-dropdown .plugin-clear_button.form-select .clear-button, jb-dropdown .plugin-clear_button.single .clear-button,
jb-select .plugin-clear_button.form-select .clear-button,
jb-select .plugin-clear_button.single .clear-button {
  right: max(var(--ts-pr-caret), 8px);
}
jb-dropdown .plugin-clear_button.focus.has-items .clear-button, jb-dropdown .plugin-clear_button:not(.disabled):hover.has-items .clear-button,
jb-select .plugin-clear_button.focus.has-items .clear-button,
jb-select .plugin-clear_button:not(.disabled):hover.has-items .clear-button {
  opacity: 1;
}
jb-dropdown .ts-wrapper .dropdown-header,
jb-select .ts-wrapper .dropdown-header {
  position: relative;
  padding: 10px 8px;
  border-bottom: 1px solid #d0d0d0;
  background: color-mix(#fff, #d0d0d0, 85%);
  border-radius: 3px 3px 0 0;
}
jb-dropdown .ts-wrapper .dropdown-header-close,
jb-select .ts-wrapper .dropdown-header-close {
  position: absolute;
  right: 8px;
  top: 50%;
  color: #303030;
  opacity: 0.4;
  margin-top: -12px;
  line-height: 20px;
  font-size: 20px !important;
}
jb-dropdown .ts-wrapper .dropdown-header-close:hover,
jb-select .ts-wrapper .dropdown-header-close:hover {
  color: black;
}
jb-dropdown .plugin-dropdown_input.focus.dropdown-active .ts-control,
jb-select .plugin-dropdown_input.focus.dropdown-active .ts-control {
  box-shadow: none;
  border: 1px solid #d0d0d0;
}
jb-dropdown .plugin-dropdown_input .dropdown-input,
jb-select .plugin-dropdown_input .dropdown-input {
  border: 1px solid #d0d0d0;
  border-width: 0 0 1px;
  display: block;
  padding: 8px 8px;
  box-shadow: inset 0 1px 1px rgba(0, 0, 0, 0.1);
  width: 100%;
  background: transparent;
}
jb-dropdown .plugin-dropdown_input .items-placeholder,
jb-select .plugin-dropdown_input .items-placeholder {
  border: 0 none !important;
  box-shadow: none !important;
  width: 100%;
}
jb-dropdown .plugin-dropdown_input.has-items .items-placeholder, jb-dropdown .plugin-dropdown_input.dropdown-active .items-placeholder,
jb-select .plugin-dropdown_input.has-items .items-placeholder,
jb-select .plugin-dropdown_input.dropdown-active .items-placeholder {
  display: none !important;
}
jb-dropdown .ts-wrapper.plugin-input_autogrow.has-items .ts-control > input,
jb-select .ts-wrapper.plugin-input_autogrow.has-items .ts-control > input {
  min-width: 0;
}
jb-dropdown .ts-wrapper.plugin-input_autogrow.has-items.focus .ts-control > input,
jb-select .ts-wrapper.plugin-input_autogrow.has-items.focus .ts-control > input {
  flex: none;
  min-width: 4px;
}
jb-dropdown .ts-wrapper.plugin-input_autogrow.has-items.focus .ts-control > input::placeholder,
jb-select .ts-wrapper.plugin-input_autogrow.has-items.focus .ts-control > input::placeholder {
  color: transparent;
}
jb-dropdown .ts-dropdown.plugin-optgroup_columns .ts-dropdown-content,
jb-select .ts-dropdown.plugin-optgroup_columns .ts-dropdown-content {
  display: flex;
}
jb-dropdown .ts-dropdown.plugin-optgroup_columns .optgroup,
jb-select .ts-dropdown.plugin-optgroup_columns .optgroup {
  border-right: 1px solid #f2f2f2;
  border-top: 0 none;
  flex-grow: 1;
  flex-basis: 0;
  min-width: 0;
}
jb-dropdown .ts-dropdown.plugin-optgroup_columns .optgroup:last-child,
jb-select .ts-dropdown.plugin-optgroup_columns .optgroup:last-child {
  border-right: 0 none;
}
jb-dropdown .ts-dropdown.plugin-optgroup_columns .optgroup::before,
jb-select .ts-dropdown.plugin-optgroup_columns .optgroup::before {
  display: none;
}
jb-dropdown .ts-dropdown.plugin-optgroup_columns .optgroup-header,
jb-select .ts-dropdown.plugin-optgroup_columns .optgroup-header {
  border-top: 0 none;
}
jb-dropdown .ts-wrapper.plugin-remove_button .item,
jb-select .ts-wrapper.plugin-remove_button .item {
  display: inline-flex;
  align-items: center;
}
jb-dropdown .ts-wrapper.plugin-remove_button .item .remove,
jb-select .ts-wrapper.plugin-remove_button .item .remove {
  color: inherit;
  text-decoration: none;
  vertical-align: middle;
  display: inline-block;
  padding: 0 6px;
  border-radius: 0 2px 2px 0;
  box-sizing: border-box;
}
jb-dropdown .ts-wrapper.plugin-remove_button .item .remove:hover,
jb-select .ts-wrapper.plugin-remove_button .item .remove:hover {
  background: rgba(0, 0, 0, 0.05);
}
jb-dropdown .ts-wrapper.plugin-remove_button.disabled .item .remove:hover,
jb-select .ts-wrapper.plugin-remove_button.disabled .item .remove:hover {
  background: none;
}
jb-dropdown .ts-wrapper.plugin-remove_button .remove-single,
jb-select .ts-wrapper.plugin-remove_button .remove-single {
  position: absolute;
  right: 0;
  top: 0;
  font-size: 23px;
}
jb-dropdown .ts-wrapper.plugin-remove_button:not(.rtl) .item,
jb-select .ts-wrapper.plugin-remove_button:not(.rtl) .item {
  padding-right: 0 !important;
}
jb-dropdown .ts-wrapper.plugin-remove_button:not(.rtl) .item .remove,
jb-select .ts-wrapper.plugin-remove_button:not(.rtl) .item .remove {
  border-left: 1px solid #0073bb;
  margin-left: 6px;
}
jb-dropdown .ts-wrapper.plugin-remove_button:not(.rtl) .item.active .remove,
jb-select .ts-wrapper.plugin-remove_button:not(.rtl) .item.active .remove {
  border-left-color: #00578d;
}
jb-dropdown .ts-wrapper.plugin-remove_button:not(.rtl).disabled .item .remove,
jb-select .ts-wrapper.plugin-remove_button:not(.rtl).disabled .item .remove {
  border-left-color: #aaaaaa;
}
jb-dropdown .ts-wrapper.plugin-remove_button.rtl .item,
jb-select .ts-wrapper.plugin-remove_button.rtl .item {
  padding-left: 0 !important;
}
jb-dropdown .ts-wrapper.plugin-remove_button.rtl .item .remove,
jb-select .ts-wrapper.plugin-remove_button.rtl .item .remove {
  border-right: 1px solid #0073bb;
  margin-right: 6px;
}
jb-dropdown .ts-wrapper.plugin-remove_button.rtl .item.active .remove,
jb-select .ts-wrapper.plugin-remove_button.rtl .item.active .remove {
  border-right-color: #00578d;
}
jb-dropdown .ts-wrapper.plugin-remove_button.rtl.disabled .item .remove,
jb-select .ts-wrapper.plugin-remove_button.rtl.disabled .item .remove {
  border-right-color: #aaaaaa;
}
jb-dropdown :root,
jb-select :root {
  --ts-pr-clear-button: 0;
  --ts-pr-caret: 0;
  --ts-pr-min: .75rem;
}
jb-dropdown .ts-wrapper.single .ts-control, jb-dropdown .ts-wrapper.single .ts-control input,
jb-select .ts-wrapper.single .ts-control,
jb-select .ts-wrapper.single .ts-control input {
  cursor: pointer;
}
jb-dropdown .ts-control:not(.rtl),
jb-select .ts-control:not(.rtl) {
  padding-right: max(var(--ts-pr-min), var(--ts-pr-clear-button) + var(--ts-pr-caret)) !important;
}
jb-dropdown .ts-control.rtl,
jb-select .ts-control.rtl {
  padding-left: max(var(--ts-pr-min), var(--ts-pr-clear-button) + var(--ts-pr-caret)) !important;
}
jb-dropdown .ts-wrapper,
jb-select .ts-wrapper {
  position: relative;
}
jb-dropdown .ts-dropdown,
jb-dropdown .ts-control,
jb-dropdown .ts-control input,
jb-select .ts-dropdown,
jb-select .ts-control,
jb-select .ts-control input {
  color: #303030;
  font-family: inherit;
  font-size: 16px;
  line-height: 18px;
}
jb-dropdown .ts-control,
jb-dropdown .ts-wrapper.single.input-active .ts-control,
jb-select .ts-control,
jb-select .ts-wrapper.single.input-active .ts-control {
  background: #fff;
  cursor: text;
}
jb-dropdown .ts-hidden-accessible,
jb-select .ts-hidden-accessible {
  border: 0 !important;
  clip: rect(0 0 0 0) !important;
  clip-path: inset(50%) !important;
  overflow: hidden !important;
  padding: 0 !important;
  position: absolute !important;
  width: 1px !important;
  white-space: nowrap !important;
}
@media (min-width: 960px) {
  jb-dropdown,
  jb-select {
    align-self: unset;
    flex-basis: 116px;
    flex-shrink: 0;
  }
}
jb-dropdown .showlabel label,
jb-dropdown .isfocused label,
jb-select .showlabel label,
jb-select .isfocused label {
  opacity: 1;
}
jb-dropdown .input-hidden .ts-control > input,
jb-select .input-hidden .ts-control > input {
  left: -10000px;
  opacity: 0;
  position: absolute;
}
jb-dropdown label,
jb-select label {
  color: rgba(20, 30, 85, 0.7);
  margin-bottom: var(--spacing-base);
  opacity: 0;
  transition: opacity 0.3s ease-in-out;
}
jb-dropdown .disabled .ts-control,
jb-select .disabled .ts-control {
  cursor: default !important;
  opacity: 0.5;
}
jb-dropdown div.error label,
jb-select div.error label {
  color: #971b2f;
}
jb-dropdown div.error input,
jb-select div.error input {
  border-bottom: 1px solid #971b2f;
}
jb-dropdown div.error input::placeholder,
jb-select div.error input::placeholder {
  color: #971b2f;
}
jb-dropdown div.error .ts-wrapper .ts-control,
jb-select div.error .ts-wrapper .ts-control {
  border-color: #971b2f;
  color: #971b2f;
}
jb-dropdown div.error .dropdown-active .ts-control,
jb-select div.error .dropdown-active .ts-control {
  color: rgba(20, 30, 85, 0.8);
  outline: #971b2f solid thin;
}
jb-dropdown p,
jb-select p {
  color: #971b2f;
  display: block;
  margin-top: var(--spacing-base);
}
jb-dropdown p [data-error-code],
jb-select p [data-error-code] {
  display: none;
}
jb-dropdown p [data-force-initial-display],
jb-select p [data-force-initial-display] {
  display: block;
}
jb-dropdown .ts-wrapper,
jb-select .ts-wrapper {
  display: flex;
  min-height: 36px;
}
jb-dropdown .ts-wrapper.multi.has-items .ts-control,
jb-select .ts-wrapper.multi.has-items .ts-control {
  padding-left: 5px;
  padding-right: 5px;
}
jb-dropdown .ts-wrapper.multi.disabled .ts-control [data-value],
jb-select .ts-wrapper.multi.disabled .ts-control [data-value] {
  background: none;
  box-shadow: none;
  color: #999;
  text-shadow: none;
}
jb-dropdown .ts-wrapper.multi.disabled .ts-control [data-value],
jb-dropdown .ts-wrapper.multi.disabled .ts-control [data-value] .remove,
jb-select .ts-wrapper.multi.disabled .ts-control [data-value],
jb-select .ts-wrapper.multi.disabled .ts-control [data-value] .remove {
  border-color: #e6e6e6;
}
jb-dropdown .ts-wrapper.multi.disabled .ts-control [data-value] .remove,
jb-select .ts-wrapper.multi.disabled .ts-control [data-value] .remove {
  background: none;
}
jb-dropdown .ts-wrapper.dropdown-active .ts-control,
jb-select .ts-wrapper.dropdown-active .ts-control {
  color: rgba(20, 30, 85, 0.8);
  outline: #141e55 solid thin;
  overflow-y: hidden;
}
jb-dropdown .ts-wrapper.dropdown-active .ts-control::after,
jb-select .ts-wrapper.dropdown-active .ts-control::after {
  transform: rotate(0deg);
  transition: transform 0.3s ease-in;
}
jb-dropdown .ts-control,
jb-select .ts-control {
  border: 1px solid rgba(20, 30, 85, 0.2);
  border-radius: 0;
  box-shadow: none;
  color: rgba(20, 30, 85, 0.8);
  flex-wrap: nowrap;
  line-height: 26px;
  margin-bottom: 1px;
  padding: var(--spacing-base) var(--spacing-2xs);
}
jb-dropdown .ts-control > *,
jb-select .ts-control > * {
  white-space: nowrap;
}
jb-dropdown .ts-control input,
jb-select .ts-control input {
  color: #141e55;
}
jb-dropdown .ts-control input::placeholder,
jb-select .ts-control input::placeholder {
  color: rgba(20, 30, 85, 0.7);
  opacity: 1;
}
.dropdown-active jb-dropdown .ts-control,
.dropdown-active jb-select .ts-control {
  border-radius: 0;
}
jb-dropdown .ts-control::after,
jb-select .ts-control::after {
  background-image: url("data:image/svg+xml,%3C%3Fxml version='1.0' encoding='UTF-8'%3F%3E%3Csvg version='1.1' viewBox='0 0 14 8' xmlns='http://www.w3.org/2000/svg'%3E%3Cg fill='none' fill-rule='evenodd'%3E%3Cg transform='translate(-316 -34)' fill='%23141E55'%3E%3Cg transform='translate(315 30)'%3E%3Cpath transform='translate(8 11.657) rotate(-45) translate(-8 -11.657)' d='m12.58 6.2426c0.46097 0 0.83461 0.37368 0.83461 0.83461v7.745c0 0.46093-0.37364 0.83461-0.83461 0.83461s-0.83461-0.37368-0.83461-0.83461v-6.9104h-6.9104c-0.46097 0-0.83461-0.37368-0.83461-0.83461 0-0.46093 0.37364-0.83461 0.83461-0.83461h7.745z'/%3E%3C/g%3E%3C/g%3E%3C/g%3E%3C/svg%3E%0A");
  background-position: center;
  background-repeat: no-repeat;
  background-size: contain;
  content: "";
  display: block;
  height: 16px;
  position: absolute;
  right: 12px;
  top: 10px;
  transform: rotate(-180deg);
  transition: transform 0.3s ease-in;
  width: 16px;
}
jb-dropdown .focus .ts-control,
jb-select .focus .ts-control {
  box-shadow: none;
}
jb-dropdown .ts-dropdown,
jb-select .ts-dropdown {
  background-color: #f1f2f2;
  border-radius: 0;
  box-shadow: none;
  margin: 0;
}
jb-dropdown .ts-dropdown-content,
jb-select .ts-dropdown-content {
  border-top: 0;
  max-height: 285px;
  min-height: 100px;
  overflow-y: auto;
  padding-block: var(--spacing-xs);
  padding-inline: var(--spacing-2xs);
}
jb-dropdown .ts-dropdown .optgroup-header,
jb-select .ts-dropdown .optgroup-header {
  font-size: 0.85em;
  font-weight: bold;
  padding-top: 7px;
}
jb-dropdown .ts-dropdown .optgroup,
jb-select .ts-dropdown .optgroup {
  border-top: 1px solid #f0f0f0;
}
jb-dropdown .ts-dropdown .optgroup:first-child,
jb-select .ts-dropdown .optgroup:first-child {
  border-top: 0 none;
}
jb-dropdown .ts-dropdown .option,
jb-select .ts-dropdown .option {
  color: rgba(20, 30, 85, 0.8);
  line-height: 19px;
  padding: 0;
  padding-bottom: var(--spacing-3xs);
  position: relative;
}
jb-dropdown .ts-dropdown .option:last-child,
jb-select .ts-dropdown .option:last-child {
  padding-bottom: 0;
}
jb-dropdown .ts-dropdown .option span:not(.highlight),
jb-select .ts-dropdown .option span:not(.highlight) {
  backface-visibility: hidden;
  bottom: 0;
  display: inline-block;
  -moz-osx-font-smoothing: grayscale;
  overflow: hidden;
  padding-bottom: var(--spacing-base);
  pointer-events: none;
  position: relative;
  transform: translateZ(0);
  z-index: -1;
}
jb-dropdown .ts-dropdown .option span:not(.highlight)::after,
jb-select .ts-dropdown .option span:not(.highlight)::after {
  background: rgba(20, 30, 85, 0.2);
  bottom: 0;
  content: "";
  height: 1px;
  left: 0;
  position: absolute;
  transition: width 0.2s ease-out 0.7s;
  width: 25px;
  z-index: 0;
}
jb-dropdown .ts-dropdown .option.selected span::after, jb-dropdown .ts-dropdown .option:hover span::after,
jb-select .ts-dropdown .option.selected span::after,
jb-select .ts-dropdown .option:hover span::after {
  background-color: #141e55;
  transition: width 0.7s ease-out;
  width: 100%;
}
jb-dropdown .ts-dropdown .option.active,
jb-select .ts-dropdown .option.active {
  background-color: unset;
  padding: 0;
}
jb-dropdown .ts-dropdown .option.active:not(:last-child),
jb-select .ts-dropdown .option.active:not(:last-child) {
  padding-bottom: var(--spacing-3xs);
}
jb-dropdown .isregionselect,
jb-select .isregionselect {
  margin-bottom: 17px;
  position: relative;
  user-select: none;
  width: 100%;
}
@media (min-width: 960px) {
  jb-dropdown .isregionselect,
  jb-select .isregionselect {
    margin-bottom: 34px;
  }
}
jb-dropdown .isregionselect .ts-wrapper.dropdown-active .ts-dropdown,
jb-select .isregionselect .ts-wrapper.dropdown-active .ts-dropdown {
  max-height: 999px;
  opacity: 1;
  transition: max-height 0.3s ease-in-out;
}
jb-dropdown .isregionselect .ts-wrapper.dropdown-active .ts-dropdown .ts-dropdown-content,
jb-select .isregionselect .ts-wrapper.dropdown-active .ts-dropdown .ts-dropdown-content {
  max-height: 285px;
  opacity: 1;
  transition: opacity 0.3s ease-in-out 0.3s;
}
jb-dropdown .isregionselect .ts-wrapper .ts-control,
jb-select .isregionselect .ts-wrapper .ts-control {
  background-color: #141e55;
  border-bottom: 0;
  border-color: rgba(255, 255, 255, 0.2);
  border-left: 0;
  border-right: 0;
  color: #fff;
  margin-bottom: 0;
  padding: 17px 17px 16px 0;
  transition: padding 0.3s ease-in-out;
}
jb-dropdown .isregionselect .ts-wrapper .ts-control::before,
jb-select .isregionselect .ts-wrapper .ts-control::before {
  content: "";
  width: 0;
}
jb-dropdown .isregionselect .ts-wrapper .ts-control::after,
jb-select .isregionselect .ts-wrapper .ts-control::after {
  background-image: url("data:image/svg+xml;charset=utf-8,%3Csvg data-name='Ebene 1' xmlns='http://www.w3.org/2000/svg' viewBox='0 0 23.21 23.21'%3E%3Cpath d='M22.21 16.71a1 1 0 01-.7-.29l-9.9-9.9-9.9 9.9a1 1 0 01-1.42 0 1 1 0 010-1.42L11.61 3.69 22.92 15a1 1 0 010 1.41 1 1 0 01-.71.3z' fill='%23fff'/%3E%3C/svg%3E");
  height: 15px;
  right: 15px;
  top: 22px;
  width: 15px;
}
@media (min-width: 960px) {
  jb-dropdown .isregionselect .ts-wrapper .ts-control::after,
  jb-select .isregionselect .ts-wrapper .ts-control::after {
    height: 20px;
    top: 19.5px;
    width: 20px;
  }
}
jb-dropdown .isregionselect .ts-wrapper .ts-control .item,
jb-select .isregionselect .ts-wrapper .ts-control .item {
  font-size: 1.3125rem;
}
@media (min-width: 960px) {
  jb-dropdown .isregionselect .ts-wrapper .ts-control .item,
  jb-select .isregionselect .ts-wrapper .ts-control .item {
    font-size: 1.5rem;
  }
}
@media (min-width: 1437px) {
  jb-dropdown .isregionselect .ts-wrapper .ts-control .item,
  jb-select .isregionselect .ts-wrapper .ts-control .item {
    font-size: 1.75rem;
  }
}
jb-dropdown .isregionselect .ts-wrapper .ts-control:focus-visible,
jb-select .isregionselect .ts-wrapper .ts-control:focus-visible {
  outline: 0;
}
jb-dropdown .isregionselect .ts-wrapper.single.dropdown-active .ts-control,
jb-select .isregionselect .ts-wrapper.single.dropdown-active .ts-control {
  background-color: #141e55;
  border-left: 1px solid rgba(255, 255, 255, 0.4);
  border-right: 1px solid rgba(255, 255, 255, 0.4);
  border-top: 1px solid rgba(255, 255, 255, 0.4);
  color: #fff;
  padding: 17px 15px;
  transition: padding 0.3s ease-in-out;
}
jb-dropdown .isregionselect .ts-wrapper.single.dropdown-active .ts-control::before,
jb-select .isregionselect .ts-wrapper.single.dropdown-active .ts-control::before {
  background-color: rgba(255, 255, 255, 0.2);
  bottom: 1px;
  content: "";
  height: 1px;
  position: absolute;
  transition: width 0.3s ease-in-out;
  width: calc(100% - 30px);
}
jb-dropdown .isregionselect .ts-wrapper.single.input-active .ts-control,
jb-select .isregionselect .ts-wrapper.single.input-active .ts-control {
  background-color: #141e55;
  cursor: pointer;
}
jb-dropdown .isregionselect .ts-wrapper .ts-dropdown,
jb-select .isregionselect .ts-wrapper .ts-dropdown {
  background-color: #141e55;
  border-bottom-color: rgba(255, 255, 255, 0.4);
  border-left-color: rgba(255, 255, 255, 0.4);
  border-right-color: rgba(255, 255, 255, 0.4);
  border-top: 0;
  display: block !important;
  max-height: 0;
  opacity: 0;
  overflow: hidden;
}
jb-dropdown .isregionselect .ts-wrapper .ts-dropdown .ts-dropdown-content,
jb-select .isregionselect .ts-wrapper .ts-dropdown .ts-dropdown-content {
  display: block !important;
  max-height: 0;
  min-height: 0;
  opacity: 0;
}
jb-dropdown .isregionselect .ts-wrapper .ts-dropdown .ts-dropdown-content::-webkit-scrollbar,
jb-select .isregionselect .ts-wrapper .ts-dropdown .ts-dropdown-content::-webkit-scrollbar {
  background-color: transparent;
  height: 5px;
  width: 12px;
}
jb-dropdown .isregionselect .ts-wrapper .ts-dropdown .ts-dropdown-content::-webkit-scrollbar-track,
jb-select .isregionselect .ts-wrapper .ts-dropdown .ts-dropdown-content::-webkit-scrollbar-track {
  background-clip: content-box;
  background-color: transparent;
}
jb-dropdown .isregionselect .ts-wrapper .ts-dropdown .ts-dropdown-content::-webkit-scrollbar-thumb,
jb-select .isregionselect .ts-wrapper .ts-dropdown .ts-dropdown-content::-webkit-scrollbar-thumb {
  background-color: #8a8ea8;
  border-left: 4px solid #141e55;
  border-radius: 4px;
  border-right: 4px solid #141e55;
  width: 180px;
}
jb-dropdown .isregionselect .ts-wrapper .ts-dropdown .option,
jb-select .isregionselect .ts-wrapper .ts-dropdown .option {
  color: #fff;
}
jb-dropdown .isregionselect .ts-wrapper .ts-dropdown .option span:not(.highlight),
jb-select .isregionselect .ts-wrapper .ts-dropdown .option span:not(.highlight) {
  padding-bottom: 0;
}
jb-dropdown .isregionselect .ts-wrapper .ts-dropdown .option span,
jb-select .isregionselect .ts-wrapper .ts-dropdown .option span {
  font-size: 1.75rem;
  line-height: 2.5rem;
}
jb-dropdown .isregionselect .ts-wrapper .ts-dropdown .option.active span::after,
jb-select .isregionselect .ts-wrapper .ts-dropdown .option.active span::after {
  background-color: #fff;
}
jb-dropdown .isregionselect .ts-wrapper .ts-dropdown .option:first-child,
jb-select .isregionselect .ts-wrapper .ts-dropdown .option:first-child {
  padding-top: 11px;
}
jb-dropdown .isregionselect .ts-wrapper .ts-dropdown .option:last-child,
jb-select .isregionselect .ts-wrapper .ts-dropdown .option:last-child {
  padding-bottom: 7px;
}
jb-dropdown .isregionselect label,
jb-select .isregionselect label {
  font-size: 11px;
  font-size: 0.6875rem;
  line-height: 16px;
  line-height: 1rem;
  color: #fff;
  display: block;
  font-weight: 400;
  letter-spacing: 1px;
  margin-bottom: 8px;
  text-transform: uppercase;
}
jb-dropdown .iseservices,
jb-select .iseservices {
  position: relative;
  user-select: none;
  width: 100%;
}
@media (min-width: 600px) {
  jb-dropdown .iseservices,
  jb-select .iseservices {
    margin-bottom: 0;
    width: auto;
  }
}
@media (min-width: 600px) {
  jb-dropdown .iseservices .ts-wrapper.dropdown-active,
  jb-select .iseservices .ts-wrapper.dropdown-active {
    min-width: 270px;
  }
}
@media (min-width: 960px) {
  jb-dropdown .iseservices .ts-wrapper.dropdown-active,
  jb-select .iseservices .ts-wrapper.dropdown-active {
    min-width: 290px;
  }
}
jb-dropdown .iseservices .ts-wrapper.dropdown-active .ts-dropdown,
jb-select .iseservices .ts-wrapper.dropdown-active .ts-dropdown {
  border-bottom-color: rgba(255, 255, 255, 0.4);
  max-height: 999px;
  opacity: 1;
  transition: max-height 0.3s ease-in-out 0.3s;
}
jb-dropdown .iseservices .ts-wrapper.dropdown-active .ts-dropdown .ts-dropdown-content,
jb-select .iseservices .ts-wrapper.dropdown-active .ts-dropdown .ts-dropdown-content {
  max-height: 285px;
  opacity: 1;
  transition: opacity 0.3s ease-in-out 0.6s;
}
jb-dropdown .iseservices .ts-wrapper.dropdown-active::before,
jb-select .iseservices .ts-wrapper.dropdown-active::before {
  transform: scaleX(1);
}
jb-dropdown .iseservices .ts-wrapper.dropdown-active::after,
jb-select .iseservices .ts-wrapper.dropdown-active::after {
  opacity: 0.6;
  transition: opacity 0.3s ease-in-out 0s;
}
jb-dropdown .iseservices .ts-wrapper.dropdown-active .ts-control::after,
jb-select .iseservices .ts-wrapper.dropdown-active .ts-control::after {
  transform: rotate(180deg);
}
jb-dropdown .iseservices .ts-wrapper::before,
jb-select .iseservices .ts-wrapper::before {
  background-color: rgba(255, 255, 255, 0.4);
  content: "";
  height: 1px;
  left: 0;
  position: absolute;
  top: 0;
  transform: scaleX(0);
  transform-origin: left;
  transition: transform 0.3s ease-in-out;
  width: 100%;
}
jb-dropdown .iseservices .ts-wrapper .ts-control,
jb-select .iseservices .ts-wrapper .ts-control {
  align-items: center;
  background-color: transparent;
  border: 0;
  border-inline: 1px solid transparent;
  color: rgba(255, 255, 255, 0.7);
  font-size: 1.625rem;
  height: 60px;
  margin-bottom: 0;
  padding: 10px 17px 10px 0;
  transition: padding 0.3s ease-in-out 0.3s;
}
jb-dropdown .iseservices .ts-wrapper .ts-control::before,
jb-select .iseservices .ts-wrapper .ts-control::before {
  content: "";
  width: 0;
}
jb-dropdown .iseservices .ts-wrapper .ts-control::after,
jb-select .iseservices .ts-wrapper .ts-control::after {
  background-image: url("data:image/svg+xml;charset=utf-8,%3Csvg data-name='Ebene 1' xmlns='http://www.w3.org/2000/svg' viewBox='0 0 23.21 23.21'%3E%3Cpath d='M22.21 16.71a1 1 0 01-.7-.29l-9.9-9.9-9.9 9.9a1 1 0 01-1.42 0 1 1 0 010-1.42L11.61 3.69 22.92 15a1 1 0 010 1.41 1 1 0 01-.71.3z' fill='%23fff'/%3E%3C/svg%3E");
  inset: 0;
  margin-left: 10px;
  opacity: 0.6;
  position: relative;
  transition: opacity 0.3s ease-in-out;
  width: 14px;
}
@media (min-width: 960px) {
  jb-dropdown .iseservices .ts-wrapper .ts-control,
  jb-select .iseservices .ts-wrapper .ts-control {
    font-size: 1.75rem;
    line-height: 2.5rem;
  }
}
jb-dropdown .iseservices .ts-wrapper .ts-control input,
jb-select .iseservices .ts-wrapper .ts-control input {
  caret-color: transparent;
  position: absolute;
}
jb-dropdown .iseservices .ts-wrapper .ts-control:focus-visible,
jb-select .iseservices .ts-wrapper .ts-control:focus-visible {
  outline: 0;
}
jb-dropdown .iseservices .ts-wrapper.single.dropdown-active .ts-control,
jb-select .iseservices .ts-wrapper.single.dropdown-active .ts-control {
  background-color: transparent;
  border-inline-color: rgba(255, 255, 255, 0.4);
  color: #fff;
  padding: 10px 15px;
  transition: padding 0.3s ease-in-out 0.3s, border-color 0.3s ease-in-out 0.3s;
}
jb-dropdown .iseservices .ts-wrapper.single.dropdown-active .ts-control::before,
jb-select .iseservices .ts-wrapper.single.dropdown-active .ts-control::before {
  background-color: rgba(255, 255, 255, 0.2);
  bottom: 1px;
  content: "";
  height: 1px;
  position: absolute;
  transition: width 0.3s ease-in-out 0.3s;
  width: calc(100% - 30px);
}
jb-dropdown .iseservices .ts-wrapper.single.dropdown-active .ts-control::after,
jb-select .iseservices .ts-wrapper.single.dropdown-active .ts-control::after {
  opacity: 0;
  transition: opacity 0.3s ease-in-out;
}
jb-dropdown .iseservices .ts-wrapper.single.dropdown-active::after,
jb-select .iseservices .ts-wrapper.single.dropdown-active::after {
  opacity: 0.6;
  transition: opacity 0.3s ease-in-out;
}
jb-dropdown .iseservices .ts-wrapper.single.input-active .ts-control,
jb-select .iseservices .ts-wrapper.single.input-active .ts-control {
  background: transparent;
  cursor: pointer;
}
jb-dropdown .iseservices .ts-wrapper .ts-dropdown,
jb-select .iseservices .ts-wrapper .ts-dropdown {
  background-color: #141e55;
  border-bottom-color: transparent;
  border-left-color: rgba(255, 255, 255, 0.4);
  border-right-color: rgba(255, 255, 255, 0.4);
  border-top: 0;
  display: block !important;
  max-height: 0;
  opacity: 0;
  transition: border-bottom-color 0.3s ease-in-out 0.3s;
}
jb-dropdown .iseservices .ts-wrapper .ts-dropdown .ts-dropdown-content,
jb-select .iseservices .ts-wrapper .ts-dropdown .ts-dropdown-content {
  display: block !important;
  max-height: 0;
  min-height: 0;
  opacity: 0;
}
jb-dropdown .iseservices .ts-wrapper .ts-dropdown .ts-dropdown-content::-webkit-scrollbar,
jb-select .iseservices .ts-wrapper .ts-dropdown .ts-dropdown-content::-webkit-scrollbar {
  background-color: transparent;
  height: 5px;
  width: 12px;
}
jb-dropdown .iseservices .ts-wrapper .ts-dropdown .ts-dropdown-content::-webkit-scrollbar-track,
jb-select .iseservices .ts-wrapper .ts-dropdown .ts-dropdown-content::-webkit-scrollbar-track {
  background-clip: content-box;
  background-color: transparent;
}
jb-dropdown .iseservices .ts-wrapper .ts-dropdown .ts-dropdown-content::-webkit-scrollbar-thumb,
jb-select .iseservices .ts-wrapper .ts-dropdown .ts-dropdown-content::-webkit-scrollbar-thumb {
  background-color: #8a8ea8;
  border-left: 4px solid #141e55;
  border-radius: 4px;
  border-right: 4px solid #141e55;
  width: 180px;
}
jb-dropdown .iseservices .ts-wrapper .ts-dropdown .option,
jb-select .iseservices .ts-wrapper .ts-dropdown .option {
  color: #fff;
}
jb-dropdown .iseservices .ts-wrapper .ts-dropdown .option span:not(.highlight),
jb-select .iseservices .ts-wrapper .ts-dropdown .option span:not(.highlight) {
  padding-bottom: 0;
}
jb-dropdown .iseservices .ts-wrapper .ts-dropdown .option span,
jb-select .iseservices .ts-wrapper .ts-dropdown .option span {
  font-size: 1.75rem;
  line-height: 2.5rem;
}
jb-dropdown .iseservices .ts-wrapper .ts-dropdown .option.active span::after,
jb-select .iseservices .ts-wrapper .ts-dropdown .option.active span::after {
  background-color: #fff;
}
jb-dropdown .iseservices .ts-wrapper .ts-dropdown .option:first-child,
jb-select .iseservices .ts-wrapper .ts-dropdown .option:first-child {
  padding-top: 11px;
}
jb-dropdown .iseservices .ts-wrapper .ts-dropdown .option:last-child,
jb-select .iseservices .ts-wrapper .ts-dropdown .option:last-child {
  padding-bottom: 7px;
}
jb-dropdown .iseservices .ts-wrapper::after,
jb-select .iseservices .ts-wrapper::after {
  background-image: url("data:image/svg+xml;charset=utf-8,%3Csvg data-name='Ebene 1' xmlns='http://www.w3.org/2000/svg' viewBox='0 0 23.21 23.21'%3E%3Cpath d='M22.21 16.71a1 1 0 01-.7-.29l-9.9-9.9-9.9 9.9a1 1 0 01-1.42 0 1 1 0 010-1.42L11.61 3.69 22.92 15a1 1 0 010 1.41 1 1 0 01-.71.3z' fill='%23fff'/%3E%3C/svg%3E");
  background-repeat: no-repeat;
  content: "";
  height: 14px;
  opacity: 0;
  position: absolute;
  right: 15px;
  top: 25px;
  transition: opacity 0.3s ease-in-out;
  transition-delay: 0;
  width: 14px;
}
jb-dropdown .iseservices label,
jb-select .iseservices label {
  font-size: 11px;
  font-size: 0.6875rem;
  line-height: 16px;
  line-height: 1rem;
  color: #fff;
  display: block;
  font-weight: 400;
  letter-spacing: 1px;
  margin-bottom: 8px;
  text-transform: uppercase;
}
jb-dropdown .dropdown .ts-control,
jb-select .dropdown .ts-control {
  cursor: pointer;
}
jb-dropdown .dropdown .ts-dropdown .option:hover span::after,
jb-dropdown .dropdown .ts-dropdown .option.selected span::after,
jb-select .dropdown .ts-dropdown .option:hover span::after,
jb-select .dropdown .ts-dropdown .option.selected span::after {
  background-color: #fff;
}
jb-dropdown .inverted label,
jb-select .inverted label {
  color: #fff;
}
jb-dropdown .inverted .ts-dropdown,
jb-select .inverted .ts-dropdown {
  background: #141e55;
  border-color: rgba(255, 255, 255, 0.4);
  color: #fff;
}
jb-dropdown .inverted .ts-dropdown .option,
jb-select .inverted .ts-dropdown .option {
  color: #fff;
}
jb-dropdown .inverted .ts-dropdown .option span::after,
jb-select .inverted .ts-dropdown .option span::after {
  background-color: rgba(255, 255, 255, 0.2);
}
jb-dropdown .inverted .ts-dropdown .option.active span::after,
jb-select .inverted .ts-dropdown .option.active span::after {
  background-color: #fff;
}
jb-dropdown .inverted .ts-control,
jb-select .inverted .ts-control {
  background: #141e55;
  border: 1px solid rgba(255, 255, 255, 0.4);
}
jb-dropdown .inverted .ts-control input,
jb-select .inverted .ts-control input {
  color: #fff;
}
jb-dropdown .inverted .ts-control input::placeholder,
jb-select .inverted .ts-control input::placeholder {
  color: rgba(255, 255, 255, 0.8);
  opacity: 1;
}
jb-dropdown .inverted .ts-control .item,
jb-select .inverted .ts-control .item {
  color: #fff;
}
jb-dropdown .inverted .ts-control::after,
jb-select .inverted .ts-control::after {
  background-image: url("data:image/svg+xml,%3C%3Fxml version='1.0' encoding='UTF-8'%3F%3E%3Csvg version='1.1' viewBox='0 0 14 8' xmlns='http://www.w3.org/2000/svg'%3E%3Cg fill='none' fill-rule='evenodd'%3E%3Cg transform='translate(-316 -34)' fill='%23FFF'%3E%3Cg transform='translate(315 30)'%3E%3Cpath transform='translate(8 11.657) rotate(-45) translate(-8 -11.657)' d='m12.58 6.2426c0.46097 0 0.83461 0.37368 0.83461 0.83461v7.745c0 0.46093-0.37364 0.83461-0.83461 0.83461s-0.83461-0.37368-0.83461-0.83461v-6.9104h-6.9104c-0.46097 0-0.83461-0.37368-0.83461-0.83461 0-0.46093 0.37364-0.83461 0.83461-0.83461h7.745z'/%3E%3C/g%3E%3C/g%3E%3C/g%3E%3C/svg%3E%0A");
}
jb-dropdown .inverted .ts-wrapper.input-active .ts-control,
jb-select .inverted .ts-wrapper.input-active .ts-control {
  background: #141e55;
  border: 1px solid #fff;
}`;

export {
  jb_select_default
};
